import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';

@customElement('app-button')
export class AppButton extends LitElement {
    static styles = css`
        :host {
            display: inline-block;
            box-sizing: border-box;
            height: var(--height-default-button, 2.4rem);
            border-radius: 8px;
            background-color: var(--app-button-bg, var(--color-green, #34a853));
            color: #fff;
        }

        :host([square]) {
            width: var(--height-default-button, 2.4rem);
        }

        :host([circle]) {
            width: var(--height-default-button, 2.4rem);
            border-radius: 50%;
        }

        * {
            box-sizing: border-box;
        }

        a.button {
            text-decoration: none;
            border: none;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0.2em 0.5em;
            min-width: 10ch;
            height: 100%; // var(--height-default-button, 2.4rem);
            line-height: 1.1;
            transition: 220ms all ease-in-out;
            font: inherit;
        }
        a.button.icon-button { width: auto; padding: 0.35em; border-radius: 50%; }
        a.button.square { width: 100%; min-width: unset; padding: 0.2em; }
        a.button.circle { width: 100%; min-width: unset; padding: 0.2em; border-radius: 50%; }
        .button__icon { width: 1.3em; height: 1.3em; margin-right: 0.5em; display:inline-flex; }
        .button__icon--end { margin-right: 0; margin-left: 0.5em; }

        .button__icon > svg, .button__icon--end svg { width: 100%; height: 100%; }
    `;

    @property({ type: String }) label = '';
    @property({ type: String }) icon = '';
    @property({ type: String }) color = '';
    @property({ type: Boolean, reflect: true }) square = false;
    @property({ type: Boolean, reflect: true }) circle = false;
    // @property({ type: String }) variant = '';

    updated(changedProps: Map<string, any>) {
        if (changedProps.has('color')) {
            if (this.color) {
                this.style.setProperty('--app-button-bg', this.color);
            } else {
                this.style.removeProperty('--app-button-bg');
            }
        }
    }

    // private onClick(e: Event) {
    //     this.dispatchEvent(new Event('click', { bubbles: true, composed: true }));
    // }

    render() {
        //  @click=${this.onClick}
        return html`
            <a class="button ${this.square ? 'square' : ''} ${this.circle ? 'circle' : ''}" role="button">
                ${this.icon ? html`<span class="button__icon">${unsafeSVG(this.icon)}</span>` : ''}
                <span class="button__label">${this.label}</span>
            </a>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'app-button': AppButton;
    }
    // interface HTMLElementEventMap {
    //     'button-click': CustomEvent<void>;
    // }
}
